import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { TechBadge } from '../../../../components/ui/TechBadge';
import { useLanguage } from '../../../../context/LanguageContext';
import { Project } from '../../../../models/project.interface';
import { projectsService } from '../../../../services/projects.service';

const TYPE_LABELS: Record<string, Record<string, string>> = {
    software: { en: 'Software', es: 'Software' },
    content: { en: 'Content', es: 'Contenido' },
    research: { en: 'Research', es: 'Investigación' },
};

export function ProjectsSection() {
    const { lang, t } = useLanguage();
    const [projects, setProjects] = useState<Project[]>([]);

    useEffect(() => {
        setProjects(projectsService.getProjects());
    }, []);

    return (
        <SectionWrapper id="projects" title={t('section.projects')} alternate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {projects.map(project => (
                    <div
                        key={project.id}
                        className="group bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50 hover:shadow-md hover:ring-blue-500/20 hover:-translate-y-1 transition-all duration-300"
                    >
                        <div className="flex items-center gap-2 mb-2">
                            <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300">
                                {TYPE_LABELS[project.type]?.[lang] || project.type}
                            </span>
                            {project.highlight && (
                                <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                                    {project.highlight[lang]}
                                </span>
                            )}
                        </div>

                        <h3 className="text-xl font-bold text-slate-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                            {project.project_url ? (
                                <a href={project.project_url} target="_blank" rel="noreferrer noopener" className="flex items-center gap-2">
                                    {project.title[lang]}
                                    <i className="bi bi-arrow-up-right text-sm opacity-0 group-hover:opacity-100 transition-opacity" />
                                </a>
                            ) : (
                                project.title[lang]
                            )}
                        </h3>

                        <p className="text-slate-600 dark:text-slate-300 mt-2 text-sm leading-relaxed">
                            {project.description[lang]}
                        </p>

                        {project.technologies.length > 0 && (
                            <div className="flex flex-wrap gap-1.5 mt-4">
                                {project.technologies.map(tech => (
                                    <TechBadge key={tech.id} name={tech.name} size="sm" />
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
